export default "__VITE_ASSET__CGsunQXi__"